import { useParams } from "react-router-dom";
import TableGroups from "./TableGroups";
import TableGroup from "./TableGroup";

export default function Groups() {
  let { groupId } = useParams();

  return groupId ? <TableGroup groupId={groupId} /> : <TableGroups />;
}
